import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class SmallBanner extends PureComponent {

    static propTypes = {
        title: PropTypes.string
    }

    render() {
        const { title } = this.props;

        return (
            <div className={styles.smallBanner}>
                <span className={styles.title}>{title}</span>
                <div className={styles.line} />
            </div>
        );
    }
}

export default SmallBanner;
